module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 5")]), _c('br'), _c('br'), _vm._v("Somatic Experience of Emotions")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "1",
      "src": "images/line.jpg",
      "width": "256"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("D")]), _vm._v("etailed videotaped case studies reveal direct physiologic concomitants of unconscious impulses and feelings. This chapter reviews these somatic pathways.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("POSITIVE FEELINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Positive feelings, including love, are experienced with warmth or an upward moving energy and an urge to reach out and embrace. An urge to smile and touch or hold the other person exists, leading to a sensation of calm. Positive feelings cause a reduction of anxiety and defenses.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("RAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The somatic pathway of rage begins at the bottom of the body, in the feet or lower abdomen and moves causing a sensation like energy, heat, or a volcano. This sensation moves toward the neck and the sides of the head and down the arms to the hands, creating an urge to grab and perform some form of violence. Thus, it moves up each spinal level from the thoracic (back) to the cervical (neck) nerves. The experience of this urge displaces any unconscious anxiety. Thus, the person goes from being tense and restrained to being activated and free to move. Rage arises in waves that sequentially increase and then decrease. When rage is higher, anxiety is lower and vice versa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the rage has a sexual component, such as an urge to rape, the patient will feel some degree of genital sexual arousal alongside the somatic pathway of rage. Both male and female patients may feel as if they have some degree of an erect penis that can perform the act of "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("a rape. Because sexualized rage is generally contained in the deeper zones of the unconscious, therapists seldom see this type of rage before they work in those unconscious zones.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("GUILT")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Guilt manifests itself somatically as upper chest and neck pain with intense sobbing and strong ideas of remorse attached to imagery of rage toward loved ones. Guilt passes in distinct, solid waves that come and go. When the guilt is present, the person finds it impossible to speak as he is in the grips of this intense emotion. Between the waves, the person is able to speak (Davanloo 2005).")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("GRIEF")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In contrast to guilt, grief is not necessarily seen in distinct, solid waves—there is not the severe physical pain seen with guilt. The person’s thoughts relate to loss rather than remorse. You will tend to feel empathic grief with the patient when she is feeling this. Sometimes grief and guilt are felt within moments of each other, and the result is combinations of these pathways.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("COGNITIVE TO AFFECTIVE CONTINUUM")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Davanloo described and we have corroborated the direct relationship between the experience of emotions and treatment outcome (Abbass 2002a; Town, Abbass, and Bernier 2013; Johansson, Town, and Abbass 2014). There is a continuum from cognitive awareness to affective experience of emotions. In treatment, we always aim for higher levels of affective experience versus cognitive awareness of emotions. On a brain level, we activate limbic structures and memory systems as highly as possible to override defensive regions, including those of the prefrontal cortex. This process is necessary to bring not just symptom reduction but enduring character change for our neurotically disturbed patients. (See "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05fig1"
    }
  }, [_vm._v("fig. 5.1")]), _vm._v(".) Upcoming chapters will include many vignettes to illustrate emotional experiences and the processes to mobilize them.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "fig-img",
    attrs: {
      "id": "ch05fig1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "height": "256",
      "src": "images/f0043-01.jpg",
      "width": "472"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-cap"
  }, [_vm._v("Figure 5.1 Cognitive to affective continuum")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('div', {
    staticClass: "none"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_c('em', [_vm._v("Emotions and impulses each have specific somatic concomitants. There is a spectrum from cognitive awareness to somatic experiencing of emotions. In ISTDP we are always aiming for greater affective versus cognitive experiences of feelings")])]), _vm._v("."), _c('a', {
    attrs: {
      "id": "page_44"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "none"
  }, [_c('hr')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c152c9f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 93
// module chunks = 0